export const menuList = [
  {
    name: "dashboard",
    group: "main",
    groupLabel: "메인",
    header: "대시보드",
    include: ["dashboard"],
    child: [],
  },
  {
    name: "media",
    group: "main",
    header: "지면 관리",
    include: ["media", "mediaList", "mediaListDetail"],
    child: [
      {name: "media", header: "지면 등록"},
      {name: "mediaList", header: "지면 리스트", detail: "mediaListDetail"},
    ],
  },
  {
    name: "reports",
    group: "main",
    header: "보고서",
    include: ["reports", "reportsHour", "reportsMedia", "reportsInventory", "reportsAdExchange"],
    child: [
      {name: "reports", header: "일자별 보고서"},
      {name: "reportsHour", header: "시간대별 보고서"},
      {name: "reportsMedia", header: "매체별 보고서"},
      {name: "reportsInventory", header: "지면별 보고서"},
    ],
  },
  {
    name: "account",
    group: "manage",
    groupLabel: "관리",
    header: "정산 관리",
    include: ["account", "accountHistory", "accountProfile", "accountConfirm", "accountData"],
    child: [
      {name: "account", header: "정산 정보"},
      {name: "accountProfile", header: "정산 프로필 관리"},
    ],
  },
  {
    name: "platform",
    group: "manage",
    header: "플랫폼 관리",
    include: [
      "platform",
      "platformAdmin",
      "platformUserDetail",
      "platformTerm",
      "platformTermDetail",
      "platformHistory",
      "platformHistoryDetail",
      "platformAdExchange",
      "platformAdExchangeDetail",
    ],
    child: [
      {name: "platform", header: "사용자 관리", detail: "platformUserDetail"},
      {name: "platformAdmin", header: "관리자 관리"},
      {name: "platformTerm", header: "약관 관리", detail: "platformTermDetail"},
    ],
  },
  {
    name: "notice",
    group: "support",
    groupLabel: "지원",
    header: "공지사항",
    include: ["notice", "noticeDetail"],
    child: [],
  },
  {
    name: "apiGuide",
    group: "support",
    header: "도움말",
    include: ["apiGuide", "apiTest"],
    child: [
      {name: "apiGuide", header: "API 연동 가이드"},
      {name: "apiTest", header: "API 테스트 페이지"},
    ],
  },
];

export const ROLE = {
  NORMAL: "NORMAL",
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
};
